export class MetaGenerator {
  /**
   * Generar metadatos completos
   */
  generate(postData, params) {
    const content = postData.content;
    const title = content?.title || this.getDefaultTitle(params);
    const description = this.extractDescription(content) || 
                       this.getDefaultDescription(params);

    return {
      description,
      title,
      keywords: this.generateKeywords(params),
      url: params.baseUrl,
      urlImage: postData.imgPostPri,
      extra: this.generateExtraMeta(title, params, postData)
    };
  }

  /**
   * Extraer descripción del contenido
   */
  extractDescription(content) {
    if (content?.description) return content.description;
    
    const firstBody = content?.body?.[0]?.value;
    if (firstBody) {
      return firstBody.replace(/<[^>]*>/g, '').trim();
    }
    
    return null;
  }

  /**
   * Generar keywords según tipo de elección
   */
  generateKeywords(params) {
    const { typeElection, year, provincia } = params;
    
    const baseKeywords = `Elecciones ${year}, Resultados, Comicios`;
    
    const specificKeywords = {
      'presidente': 'Presidenciales, Presidente, Candidatos',
      'gobernador': `Gobernador, ${provincia}`,
      'legislativas': 'Legislatura, Diputados, Boleta única',
      'delegados': 'Delegados Comunales, Comuna, Ciudad de Buenos Aires',
      'senadores': 'Senadores, Cámara Alta',
    };

    return `${baseKeywords}, ${specificKeywords[typeElection] || typeElection}`;
  }

  /**
   * Generar meta tags extras
   */
  generateExtraMeta(title, params, postData) {
    const { year, electionType } = params;
    const publishDate = electionType === 'balotaje' 
      ? `${year}-11-19T13:00:00.000Z`
      : `${year}-10-22T19:05:00.000Z`;

    return [
      { name: "title", content: title },
      { name: "distribution", content: "global" },
      { name: "robots", content: "max-image-preview:large" },
      { property: "og:title", content: title },
      { property: "og:type", content: "article" },
      { property: "og:image", content: postData.imgPostPri },
      { property: "article:published_time", content: publishDate },
      { property: "article:modified_time", content: postData.content?.last_update || new Date().toISOString() },
      { property: "article:section", content: "Política" },
      { name: "twitter:card", content: "summary_large_image" },
    ];
  }

  /**
   * Título por defecto
   */
  getDefaultTitle(params) {
    return `Elecciones ${params.year} - ${params.typeElection} - ${params.provincia || 'Argentina'}`;
  }

  /**
   * Descripción por defecto
   */
  getDefaultDescription(params) {
    return `Resultados de las elecciones ${params.year} para ${params.typeElection} en ${params.provincia || 'Argentina'}`;
  }
}